const Email = () => (
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="5" width="12" height="9" rx="1.5" stroke="#818181" strokeWidth="1.5" />
    <path
      d="M3 7.25024L8.32918 9.91483C8.75147 10.126 9.24853 10.126 9.67082 9.91483L15 7.25024"
      stroke="#818181"
      strokeWidth="1.5"
    />
  </svg>
);

export default Email;
